import React from 'react';
import { connect } from 'react-redux';
import {
  getTestResultTitle,
  hasReportDocuments,
  getTestPassedTitle,
  isComplete,
  isUnderReview,
  isResultNoTesting
} from 'helpers/RequestTestsHelper';
import { formatDate } from 'helpers/DateHelper';

const TestStatusTableRow = ({ tests, request }) => {
  if (!tests || !tests.length) return null;

  const testModule = tests[0];
  const {
    planversion,
    actualstartdate,
    actualenddate,
    reportedat,
    reports,
    requesttestpassedstatusid
  } = testModule;

  const { testStatus } = request;

  const renderResult = () => {
    const mainTitle = getTestResultTitle(testStatus);
    const tailTitle =
      isComplete(testStatus) || isUnderReview(testStatus)
        ? `— ${getTestPassedTitle(requesttestpassedstatusid)}`
        : '';
    return <b>{`${mainTitle} ${tailTitle}`}</b>;
  };

  const renderPassTestInfo = () => {
    if (hasReportDocuments(reports)) {
      return (
        <div>
          Test Plan Version: {planversion}
          <br />
          Test Start Date: {formatDate(actualstartdate)}
          <br />
          Test Finish Date: {formatDate(actualenddate)}
          <br />
          Test Reported Date: {formatDate(reportedat)}
        </div>
      );
    }
  };

  const renderNoTestingInfo = () => {
    if (isResultNoTesting(requesttestpassedstatusid)) {
      return <div>Test Plan Version: {planversion}</div>;
    }
  };

  return (
    <td className="col-xs-3 col-sm-3 col-md-3">
      <b>{renderResult()}</b>
      <br />
      {renderPassTestInfo()}
      {renderNoTestingInfo()}
    </td>
  );
};

function mapStateToProps({ tests, request }) {
  return { tests, request };
}

export default connect(mapStateToProps)(TestStatusTableRow);
